import { Component, Input, AfterViewInit, Inject } from '@angular/core';
//import { SimpleModalComponent } from "ngx-simple-modal";
import { take, map } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmModel {
  title: string;
  access?: string[];
  urlImage?: string;
  subtitle?: string;
  lista?: any[];
  textTimer: number;
}

@Component({
  selector: 'app-access-dialog',
  templateUrl: './access-dialog.component.html',
  styleUrls: ['./access-dialog.component.scss']
})
export class AccessDialogComponent implements AfterViewInit {
  @Input() title: string = "";
  @Input() access: string[] = [];
  @Input() urlImage: string = '';
  @Input() subtitle: string = '';
  @Input() lista: any[] = [];
  @Input() textTimer: number = 0;

  confirmData: ConfirmModel = {
    title: "",
    access: [],
    urlImage: "",
    subtitle: "",
    lista: [],
    textTimer: 0
  };

  public counter$: Observable<number> = new Observable;

  public counter = 0;

  constructor(public dialogRef: MatDialogRef<AccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel,) {
      this.confirmData = data;

      timer(0, 1000).pipe(
        // Take values until the specified duration is reached
        take(this.confirmData.textTimer + 1),
        // Subtract the emitted values from the duration to get the countdown
        map((value) => this.confirmData.textTimer - value)
      ).subscribe((counter) => {
        this.counter = counter;

        // Close the dialog when the countdown reaches zero
        if (counter === 0) {
          // this.close();
        }
      });
  }

  //confirm
  confirm() {
    // we set modal result as true on click on confirm button,
    // then we can get modal result from caller code
    // this.result = true;
    // this.close();
    this.dialogRef.close(true);
  }

  //cancel
  close() {
    this.dialogRef.close(false);
  }

  async ngAfterViewInit(): Promise<void> {
    if (this.confirmData.textTimer > 0) {
      this.counter$ = await timer(0, 1000).pipe(
        take(this.textTimer),
        map(() => {
          return --this.textTimer
        }));
    }
  }
}
